<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Wnioski</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-tabs v-model="activeTab">
            <v-tab v-for="(tab, index) in tabs" :key="index" exact :to="route(tab)">{{ tab.text }}</v-tab>
          </v-tabs>
        </v-flex>
      </v-layout>

      <material-table :headers="headers" :items="list" :total-count="count" @details="goToDetails" />
    </material-card>
  </v-container>
</template>

<script>
import {
  address,
  ApplicationState,
  ApplicationStateMultipleTranslation,
  ApplicationStateTranslation,
  dateFilter,
  DisplayApplicationState
} from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';

// @vuese
// Lista wniosków
// @group application
export default {
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Search
  },
  computed: {
    ...mapState({
      canLink: state => state.access.checked['APPLICATION.GET']
    }),
    headers() {
      return [
        { text: 'ID', value: 'id', orderBy: 'id', link: this.canLink },
        {
          text: 'Nazwisko, imię',
          link: this.canLink,
          value: 'lastName',
          orderBy: ['lastName', 'firstName'],
          render: item => item.lastName + ' ' + item.firstName
        },
        {
          text: 'Adres',
          value: 'street',
          orderBy: ['street', 'homeNumber', 'localNumber', 'postalCode', 'city'],
          render: item => address(item)
        },
        {
          text: 'Punkt odbioru',
          value: 'collectionPoint',
          sortable: false,
          render: item => (item.collectionPoint ? item.collectionPoint.name : 'Brak')
        },
        {
          text: 'Data',
          value: 'created',
          orderBy: 'created',
          width: '120px',
          render: item => dateFilter(item.created)
        }
      ];
    }
  },
  mixins: [
    listMixin('application', {
      listError: 'Wystąpił błąd podczas pobierania listy wniosków.',
      getError: 'Wystąpił błąd podczas pobierania danych wniosku.',
      deleted: 'Usunięto wniosek.',
      deleteError: 'Nie udało się usunąć wniosku.'
    })
  ],
  data() {
    return {
      activeTab: this.$route.path,
      tabs: [
        {
          text: ApplicationStateMultipleTranslation[DisplayApplicationState.SUBMITTED],
          route: { name: 'applicationsByState', params: { state: DisplayApplicationState.SUBMITTED } },
          value: 'SUBMITTED'
        },
        {
          text: ApplicationStateMultipleTranslation[DisplayApplicationState.ACCEPTED],
          route: { name: 'applicationsByState', params: { state: DisplayApplicationState.ACCEPTED } }
        },
        {
          text: ApplicationStateMultipleTranslation[DisplayApplicationState.REJECTED],
          route: { name: 'applicationsByState', params: { state: DisplayApplicationState.REJECTED } }
        }
      ]
    };
  },
  methods: {
    // @vuese
    // Konfiguracja filtrów (dodanie state)
    filters(pagination, route) {
      return { ...pagination, state: route.params.state };
    },
    // @vuese
    // Przenosi do szczegółów wniosku
    goToDetails(application) {
      this.$router.push({ name: 'application', params: { applicationId: application.id } });
    },

    // @vuese
    // Zwraca routing zakładki
    route(tab) {
      return { ...tab.route, query: { ...this.$route.query, page: 1 } };
    }
  },
  watch: {
    $route(to, from) {
      store.commit('breadcrumbs/set', [
        { text: 'Wnioski', to: { name: 'applications' }, exact: true },
        { text: ApplicationStateMultipleTranslation[DisplayApplicationState[to.params.state]], disabled: true }
      ]);
    }
  }
};
</script>
